import React, { Component } from 'react';
// import { Link } from 'react-router-dom';
import { Dropdown, DropdownMenu, DropdownToggle, Label, UncontrolledTooltip } from 'reactstrap';
import { Clock, User } from 'react-feather';
import { connect } from 'react-redux';
import moment from 'moment';
import _isEmpty from 'lodash/isEmpty';
import { getAllUsersData } from 'service/users/action';

import './styles.scss';

class UserLogsDropdown extends Component {
    constructor(props) {
        super(props);
        this.toggleDropdown = this.toggleDropdown.bind(this);
        this.state = {
            dropdownOpen: false,
        };
    }

    toggleDropdown() {
        this.setState({
            dropdownOpen: !this.state.dropdownOpen,
            theme: parseInt(localStorage.getItem('theme')),
        });
        if (!this.state.dropdownOpen) this.props.getAllUsersData(true);
    }

    render() {
        const tag = this.props.tag || 'div';
        const usersList = this.props.rowData
            .sort((a, b) => {
                return new Date(b.last_login) - new Date(a.last_login);
            })
            .slice(0, 10);
        return (
            <React.Fragment>
                <Dropdown
                    style={{ marginBottom: '-10px' }}
                    isOpen={this.state.dropdownOpen}
                    toggle={this.toggleDropdown}
                    className="d-none d-lg-block"
                    tag={tag}
                >
                    <DropdownToggle
                        id="userLogs"
                        data-toggle="dropdown"
                        tag="a"
                        className="nav-link mr-0"
                        onClick={this.toggleDropdown}
                        aria-expanded={this.state.dropdownOpen}
                    >
                        <Clock />
                    </DropdownToggle>
                    <DropdownMenu style={{ overflow: 'auto', height: '30vh' }} right className="for-drop-down-menu-ul px-0">
                        <Label style={{ color: '#4BB3BC' }} className="ml-2">
                            Login Status :
                        </Label>
                        {usersList.map((data) => (
                            <>
                                <div className="ml-2">
                                    <User style={{ height: 20, marginBottom: 5, marginRight: 10 }} className="icon-dual" />
                                    <b>{data.displayname}</b> logged in at{' '}
                                    <span style={{ color: 'mediumblue' }}>
                                        {moment(new Date(data.last_login)).format('YYYY-MM-DD HH:mm:ss')}
                                    </span>
                                </div>
                                <hr />
                            </>
                        ))}
                    </DropdownMenu>
                </Dropdown>
                <UncontrolledTooltip placement="left" target="userLogs">
                    User Activity
                </UncontrolledTooltip>
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        rowData: state.usersReducer.userData,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getAllUsersData: (isLogs) => dispatch(getAllUsersData(isLogs)),
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(UserLogsDropdown);
